<template>
    <div style="padding: 6px 0;" class="simple-news">
        <ul class="list" style="min-height: 560px">
            <li v-for="(item, index) in list" :key="index" class="item" @click="toDetail(item)">
                <img src="../../../static/images/lan0.png" alt="" />
                <a class="title">{{ item.title }}</a>
                <span class="date"> [{{ item.releaseTime }}]</span>
            </li>
        </ul>
        <div class="page">
            <Page :total="total" show-total :page-size="searchParams.pageSize" :current="searchParams.page" @on-change="pageChange"></Page>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            list: {
                type: Array,
                default: []
            },
            searchParams: {
                type: Object,
                default: {}
            },
            total: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {

            }
        },
        methods: {
            pageChange(val) {
                this.$emit("pageChange", val)
            },

            toDetail(item) {
                switch (item.type) {
                    case '1': {
                        window.open(item.url)
                        break
                    }
                    case '2': {
                        let routeUrl = this.$router.resolve({
                            path: "/index/wumei/NewsDetail",
                            query: {
                            id: item.id,
                            activeName: item.dictName
                        },
                        });
                        window.open(routeUrl.href, "_blank");
                        break
                    }
                    case '3': {
                        window.open(item.fileUrl)
                        break
                    }
                }

            },
        },
    }
</script>

<style scoped>
    .simple-news .list .item {
        border-bottom: 1px #cccccc dashed;
        line-height: 0.44rem;
        position: relative;
        cursor: pointer;
        display: flex;
    }

    .simple-news .list .item img {
        position: absolute;
        top: 0.16rem;
    }

    .simple-news .list .item .title {
        color: #323232;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-all;
        flex: 1;
        margin-right: 0.3rem;
        margin-left: 0.16rem;
        transition: all .2s;
        -webkit-transition: all .2s;
        -moz-transition: all .2s;
        -ms-transition: all .2s;
        -o-transition: all .2s;
    }

    .simple-news .list .item .title:hover {
        color: #DF4501;
    }

    .simple-news .list .item .date {
        /* color: #095494; */
        color: #999;
    }
</style>


// WEBPACK FOOTER //
// src/components/wumei/SimpleList.vue